module.exports = __webpack_public_path__ + "static/media/30OIOS3.81658755.jpg";